import {dematerialize, materialize, tap} from "rxjs/operators";
import {Observable} from "rxjs";

/**
 * It calls a callback function when the loading status of the observable changes.
 * @param onIsLoadingChangesCallBack - (isLoading: boolean) => void
 */
export function onIsLoadingChanges(onIsLoadingChangesCallBack: (isLoading: boolean) => void) {
    onIsLoadingChangesCallBack(true);
    return function <T>(source: Observable<T>): Observable<T> {
        return source.pipe(
            materialize(),
            tap(() => onIsLoadingChangesCallBack(false)),
            dematerialize(),
        )
    }
}